import { render, staticRenderFns } from "./Races.vue?vue&type=template&id=182ac5bc&scoped=true"
import script from "./Races.vue?vue&type=script&lang=js"
export * from "./Races.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182ac5bc",
  null
  
)

export default component.exports